import { ModKeys } from "@intelligems/ig-types";
import { OpenDialogAction } from "@src/store/slices/global";

export type AlertState = {
  key: string;
  customMessage?: string;
  docLink?: string;
  openDialog?: {
    linkText: string;
    payload?: OpenDialogAction["payload"];
  };
};

export type IExperienceInfoStateSlice = {
  alertOpen: boolean;
  warnings: AlertState[];
  errors: AlertState[];
  activatedModArr: ModKeys[];
  showErrors: boolean;
  activatedVariationMods: Record<
    string,
    {
      mods: ModKeys[];
    }
  >;
};

export const initialExperienceInfoStateSlice: IExperienceInfoStateSlice = {
  alertOpen: false,
  warnings: [],
  errors: [],
  activatedModArr: [],
  showErrors: false,
  activatedVariationMods: {},
};

export interface ExperienceStateIssue {
  error: boolean;
  key: string;
  type: "warning" | "error";
  customMessage?: string;
  docLink?: string;
  openDialog?: {
    linkText: string;
    payload?: OpenDialogAction["payload"];
  };
}
